<script>
import {
    Block,
    BlockTitle,
    Link,
    Tabs,
    Tab
} from 'framework7-svelte';
import { onMount } from 'svelte';
onMount(() => {

})
</script>
<style>

</style>
<BlockTitle >Responsables del Sistema de Alerta Temprana de Incendios Forestales</BlockTitle>
<Block strong mediumInset style="text-align: justify;">
    <strong>Dra. María Isabel Cruz López</strong>
    <p>
        Coordinación de Sistemas, Monitoreo e Información Geoespacial, CONABIO.
        <br>Implementación, desarrollo y coordinación del SATIF
    </p>
    <strong>Mtro. Martín Cuahutle Cuahutle</strong>
    <p>
        Especialista en Geocomputación, Consultor.
        <br>Responsable y desarrollo del SATIF.
    </p>
    <strong>Mtra. Laura Merit González Ramírez</strong>
    <p>
        Especialista "C" en Sistemas de Información Geográfica, CONABIO.
        <br>Manejo y análisis de datos del SATIF.
    </p>
    <strong>Mtro. Abraham Cuevas González</strong>
    <p>
        Subdirección de Desarrollo de Plataformas Geoespaciales, CONABIO.
        <br>Desarrollo del SATIF.
    </p>
    <strong>Ing. Raúl Jiménez Rosenberg</strong>
    <p>
        Sectretario Ejecutivo, CONABIO.
    </p>
    <strong>Colaboradores anteriores:</strong>
    <p>
        Rainer Ressl, Frank Michael Oliver Schmit, Silke Kerkhoff, Gerardo López Saldaña, Erik de Badts,
        Luis Sánchez Martínez, Albertus Johannes Wickel, Alejandra Cervera Taboada,
        Juan Manuel Escamilla Mólgora, Jorge Humberto Muñoa Coutiño, Silvestre Ruíz Salinas, Alondra Balbuena Medina.
    </p>
</Block>

